import React, { useState, useEffect } from 'react'
import useStateRef from 'react-usestateref';
import MyAccountCommonize from './MyAccountCommonize';
import { useSelector } from 'react-redux';
import { Link,useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import BreadCrumbsContainer from '../BreadCrumbs/BreadCrumbsContainer';

function MyAccount({ containerObject, templateName, contentId, dataZone }) {
    function handlePrintPage() {
        window.print()
    }

    const location = useLocation();
    const successMsgState = location.state ? location.state : '';
    const profileDetails = useSelector(state => state.getProfileDetails.profileDetails)
    const registerMessage = useSelector(state => state.registerMsgReducer.message)
    const history = useHistory()

    const breadCrumbs = {
        "ancestors": [],
        productName: "My Account"
    };
    useEffect(() => {
        var searchParam = window.location.search
        var uri = searchParam.split("?")

        if (profileDetails && profileDetails.transient && successMsgState === '' && uri && uri != null && uri.length > 0 && uri[1] != "DPSLogout=true") {
            history.push("/account/login?resume=prev")
        }
    }, [profileDetails])
    return (
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content c-shop-list-detail`}>
            {profileDetails && !profileDetails.transient ? 
            <>
            <div className="row align-items-center gx-0 cb-breadcrum-list">
                <div className="col-md-11 header-padding-row">
                     <BreadCrumbsContainer breadCrumbs={breadCrumbs} pageType="MyAccount"/>
                </div>

                <div className="col-12 col-md-1 header-padding-row d-none d-lg-block">
                    <button className="btn btn-light c-print-btn text-end" type="button" onClick={handlePrintPage}>
                        <i className="fas fa-print" ></i>Print
                    </button>
                </div>

            </div>
            <div className="row page-min-height gx-0 c-shopping-list-item-padding">
                <MyAccountCommonize />
                <div id="content" className="col-lg-9 c-shopping-list-item-col c-my-profile-details">

                    {successMsgState && !successMsgState.previousUrl ?
                        <div class={`alert d-block ${successMsgState && successMsgState.tempB2IMsg ? 'alert-danger' : successMsgState && successMsgState.accountSuccCreateMsg ? 'alert-success' : ''} `} role="alert">
                            {successMsgState && successMsgState.tempB2IMsg ? successMsgState.tempB2IMsg :
                                successMsgState && successMsgState.accountSuccCreateMsg ? successMsgState.accountSuccCreateMsg : ''}
                        </div>
                        : ''}
                    <h1 className="right-panel-heading d-none d-lg-block">My Account</h1>
                    <div className="row">
                        <div className="col-md-6 d-none d-lg-block">
                            <div className="c-account-item">
                                <h2 className="c-account-item-title"><Link to="/account/profile">My Profile</Link></h2>
                                <p className="c-account-item-content">
                                    Update your personal information, including your name, email address, password, and security settings.
                                </p>
                            </div>
                        </div>
                        {profileDetails && profileDetails.userType && profileDetails.userType == '2' &&
                            <div className="col-md-6 d-none d-lg-block">
                                <div className="c-account-item">
                                    <h2 className="c-account-item-title"><Link to="/account/b2i/organization-user">My Organization</Link></h2>
                                    <p className="c-account-item-content">
                                        View important information for your organization, including available discount terms, admin contact information, Carolina Account Number, tax exemption status, and more.
                                    </p>
                                </div>
                            </div>
                        }
                        <div className="col-md-6 d-none d-lg-block">
                            <div className="c-account-item">
                                <h2 className="c-account-item-title"><Link to="/account/list">Shopping Lists</Link></h2>
                                <p className="c-account-item-content">
                                    Save items you purchase frequently, easily repeat orders, share lists with others, and import/export products using Excel templates.
                                </p>
                            </div>
                        </div>
                        {profileDetails && profileDetails.userType && profileDetails.userType != '3' &&
                            <div className="col-md-6 d-none d-lg-block">
                                <div className="c-account-item">
                                    <h2 className="c-account-item-title"><Link to="/account/order">Order History</Link></h2>
                                    {
                                        profileDetails && profileDetails.userType && profileDetails.userType == '2' ?
                                            <p className="c-account-item-content">
                                                Quickly access previous online orders, track current orders, view detailed invoice information for your organization, and more.
                                            </p>
                                            : profileDetails && profileDetails.userType && profileDetails.userType == '1' &&
                                            <p className="c-account-item-content">
                                                Quickly access previous online orders, track current orders, repeat previous orders, and more.
                                            </p>
                                    }
                                </div>
                            </div>
                        }
                        <div className="col-md-6">
                            <div className="c-account-lab">
                                <p className="c-accountlab-img"><img src="	/images/static/college/lists/lists.png" /></p>
                                <div className="c-accountlab-content">
                                    <h3 className="c-account-item-title">Save Time with College Lab Lists!</h3>
                                    <p className="c-account-item-content">Our product experts worked with colleges around the country to develop custom material lists for the most popular intro college-level biology labs.</p>
                                    <Link to="/landing/college/materials-for-popular-biology-labs?intid=myacct_t_collegebiolists" className="c-account-labLink text-end">View College Lab Lists »</Link>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
            </> : "" }
        </div>
    );
}

export default MyAccount;
